.preview a {
  cursor: default;
}
